import React, { useContext, useMemo } from 'react';
import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { GridDetailsPanel } from 'utils/components/GridDetailsPanel/GridDetailsPanel';
import { getCorporateActionsColDefs } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { getPanelColumnDefs } from 'widgets/corpActions/widget/details/sections';
import './CorporateActionsCapsuleContentBack.scss';
import classNames from 'classnames';
import { getDaysDiffDesc } from 'widgets/corpActions/capsule/components/corporateActionsCapsuleData';
import { getSymbolEventTypeValue } from 'widgets/corpActions/api/SymbolEventsRequest';
import AppContext from 'app/AppContext';

export interface CorporateActionsCapsuleBackProps {
    className: string;
    data?: SymbolEvent;
    onClick: () => void;
}

export function CorporateActionsCapsuleContentBack(
    props: CorporateActionsCapsuleBackProps
) {
    const { data, onClick, className } = props;
    const context = useContext(AppContext);

    const sections = data ? getPanelColumnDefs(data, false) : [];

    const colDefs = useMemo(
        () => getCorporateActionsColDefs(context),
        [context]
    );

    const subText = getDaysDiffDesc(
        data?.effectiveDate ?? 0,
        new Date().getTime()
    );

    const cssClasses = classNames(
        'CorporateActionsCapsuleContentBack',
        'flippable',
        className
    );

    return (
        <div className="CorporateActionsCapsuleContentContainer">
            <div className={cssClasses} onClick={onClick}>
                {data && (
                    <>
                        <div className="title">
                            {getSymbolEventTypeValue(data.type)}{' '}
                            <span className="sub-text">{subText}</span>
                        </div>
                        <GridDetailsPanel
                            colDefs={colDefs}
                            entity={data}
                            panelColumnDefs={sections}
                            width={220}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
